import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: 0,
  },
  chipRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.75),
    padding: theme.spacing(1, 0),
  },
  searchBox: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
  selectedCount: {
    fontSize: '0.8rem',
    color: theme.palette.text.secondary,
    padding: theme.spacing(0.5, 0),
    minHeight: 24,
  },
  driverList: {
    flex: 1,
    overflowY: 'auto',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    '&::-webkit-scrollbar': {
      width: '0.4em',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,.1)',
    },
  },
  driverItem: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0.5, 1),
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  driverName: {
    flex: 1,
    fontSize: '0.9rem',
  },
  statusChip: {
    fontSize: '0.7rem',
    height: 18,
    marginLeft: theme.spacing(0.5),
  },
  emptyState: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
  },
  areaGroupHeader: {
    padding: theme.spacing(0.5, 1, 0.5, 0),
    backgroundColor: theme.palette.grey[50],
  },
  areaGroupLabel: {
    padding: theme.spacing(0, 1),
    fontSize: '0.75rem',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
    color: theme.palette.text.secondary,
  },
  selectAreaBtn: {
    fontSize: '0.7rem',
    padding: theme.spacing(0.25, 0.75),
    minWidth: 'unset',
  },
}));
